import {
  adviserFCAMask,
  telephoneMask,
  sortCodeMask,
  accNumberMask,
  yearsMask,
  MBCcurrencyMask,
  percentageMask,
  postcodeMask,
  dateMask,
  numberMask,
  caseNumberMask,
  percentageDecimalMask,
} from 'shared/Inputs/inputMasks';
import { toUpperCase } from 'utils/text';
import { VARIANTS_TYPES } from './variants.types';
import { VISIBLE_DATE_FORMAT } from 'utils/date';

const variants = new Map<VARIANTS_TYPES, any>([
  [VARIANTS_TYPES.TEXT, {}],
  [
    VARIANTS_TYPES.PHONE,
    {
      mask: telephoneMask,
      showMask: true,
    },
  ],
  [
    VARIANTS_TYPES.POSTCODE,
    {
      mask: postcodeMask,
      transformValue: toUpperCase,
    },
  ],
  [
    VARIANTS_TYPES.ADVISER_FCA,
    {
      mask: adviserFCAMask,
      transformValue: toUpperCase,
    },
  ],
  [
    VARIANTS_TYPES.SORT_CODE,
    {
      mask: sortCodeMask,
    },
  ],
  [VARIANTS_TYPES.BANK_ACC_NUMBER, { mask: accNumberMask }],
  [VARIANTS_TYPES.CASE_NUMBER, { mask: caseNumberMask }],
  [VARIANTS_TYPES.YEARS, { mask: yearsMask }],
  [VARIANTS_TYPES.CURRENCY, { mask: MBCcurrencyMask }],
  [VARIANTS_TYPES.PERCENTAGE, { mask: percentageMask }],
  [VARIANTS_TYPES.DATE, { mask: dateMask, showMask: true, placeholder: VISIBLE_DATE_FORMAT }],
  [VARIANTS_TYPES.NUMBER, { mask: numberMask }],
  [VARIANTS_TYPES.DECIMAL_PERCENTAGE, { mask: percentageDecimalMask }],
]);

export default variants;
